import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import GridItem from './GridItem';

const TimeInput = ({label,setInput,input})=>{

return(
	<GridItem>
       <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
            views={['hours', 'minutes']} format="hh:mm"
            label={label}
            sx={{width:{xs:350,md:300}}}
            onChange={(newValue) => setInput(newValue)}
            placeholder={`${label}...`}
            value={input}
        />    
       </LocalizationProvider>
	</GridItem>


)
}

export default TimeInput